module.exports = __webpack_public_path__ + "img/frontier.ff171007.png";